<template>
    <div>资源库</div>
</template>

<script>
    export default {
        name: "Resources"
    }
</script>

<style scoped>

</style>